import { Input } from 'antd';
import { useIntl } from 'react-intl';

import { Props } from './SearchForm.model';

import styles from './SearchForm.module.scss';

const SearchForm = ({
		searchByTermDefaultValue,
		searchByTermLabel,
		onSearchByTerm,
	}: Props) => {
	const intl = useIntl();

	const { Search } = Input;

	return (
		<div className={styles.wrapper}>
			<div className={styles.searchByTerm}>
				<Search
					bordered={false}
					defaultValue={searchByTermDefaultValue}
					placeholder={searchByTermLabel || intl.formatMessage({id: 'formPlaceholders.searchUser'})}
					size="large"
					style={{ width: '100%' }}
					onSearch={(value) => {
						onSearchByTerm && onSearchByTerm(value);
					}} />
			</div>
		</div>
	);
}

export default SearchForm;